export default "__VITE_ASSET__BFeTMK9j__"